.q{justify-content:center;}